import { render, staticRenderFns } from "./ProgressReportRoute.vue?vue&type=template&id=2e10c407"
import script from "./ProgressReportRoute.vue?vue&type=script&lang=js"
export * from "./ProgressReportRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports